/**
 * Awesome Screen Recorder & Screenshot
 *
 * Screen recorder injecting a camera overlay; its UI pages are exposed to every origin.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 4.4.41.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'nlipoenfbbikpbjkfpfillcgkoblgpmj';
export const awesomeScreenshot: ExtensionDefinition = {
  id: ID,
  name: "Awesome Screen Recorder & Screenshot",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3000000,
  notes: "Screen recorder injecting a camera overlay; its UI pages are exposed to every origin.",
  signals: [
    { id: 'war-camera-html', kind: 'web-accessible-resource',
      description: 'Fetch camera.html, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'camera.html') },
    { id: 'war-camera-embed-html', kind: 'web-accessible-resource',
      description: 'Fetch camera-embed.html, exposed to every origin.',
      weight: 0.5, run: () => probeFetch(ID, 'camera-embed.html') },
  ],
};
